import { H5, H6 } from '@repo/ui/components/Typography';
import { handleTextOverflow } from '@repo/ui/components/utilities';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const ButtonWrapper = styled.div<{ hasAction?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  background: ${themeStyle.varBackgroundAlt};
  border: 1px solid ${themeStyle.varInkLight};

  &:hover {
    background: ${themeStyle.varInkLight};
    ${(hasAction) => (hasAction ? `cursor: pointer;` : '')}
  }

  ${H5} {
    height: 18px;
  }
  ${H6} {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
  }
`;

export const TeamInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  ${handleTextOverflow}
`;
